import { Channel } from '@nemuru-eng/js-api-client';
import { useCallback } from 'react';

import { ChannelTypeIcons } from '@/components/modules/MerchantDetail/MerchantStructure/constants/ChannelTypeIcons';
import { ChannelOrAgentDropdownSelector } from '@/components/shared/components/AgentSelectionComponent/components/ChannelOrAgentDropdownSelector';
import { ChannelMap } from '@/components/shared/components/AgentSelectionComponent/maps/channel.map';
import { AgentSelectionComponentStateSetter } from '@/components/shared/components/AgentSelectionComponent/types/AgentSelectionComponentStateSetter';
import { SelectItem } from '@/components/shared/components/AgentSelectionComponent/types/SelectItem';
import { Text } from '@/components/shared/components/Text';

export interface ChannelSelectorProps {
  selectedChannel: Channel | undefined;
  channels: Channel[] | undefined;
  disabled?: boolean;
  setState: AgentSelectionComponentStateSetter;
}

export const ChannelSelector = ({ selectedChannel, channels, disabled, setState }: ChannelSelectorProps) => {
  const resetItem = useCallback(() => !selectedChannel, [selectedChannel]);

  return (
    <ChannelOrAgentDropdownSelector
      title={<Text tId={'SALES_CHANNEL'} />}
      subtitle={<Text tId={'SELECT_A_CHANNEL'} />}
      resetItem={resetItem}
      disabled={disabled}
      icon={selectedChannel ? ChannelTypeIcons[selectedChannel.type] : 'storefront'}
      value={selectedChannel ? ChannelMap.toSelectItem(selectedChannel) : undefined}
      items={channels?.map(ChannelMap.toSelectItem) as SelectItem[]}
      handleClickItem={(item) => {
        setState((state) => ({ ...state, selectedChannel: channels?.find((channel) => channel.id === item.id) }));
      }}
    />
  );
};
